
import { BarChart3, FileText, Activity, BookOpen, Users } from 'lucide-react';
import { NavItem } from '../types';

const reportsItems: NavItem[] = [
  {
    title: 'Reports',
    path: '/app/reports',
    icon: BarChart3,
    requiredPermissions: [], // No permission required on parent - visibility determined by children
    children: [
      {
        title: 'My Activity',
        path: '/app/my/activity',
        icon: Activity,
        requiredPermissions: ['my_activity.read'] // Consistent with route permissions
      },
      {
        title: 'All Activity',
        path: '/app/reports/all-activity',
        icon: BarChart3,
        requiredPermissions: ['reports_all_activity.read']
      },
      {
        title: 'Call Report',
        path: '/app/reports/calls',
        icon: FileText,
        requiredPermissions: ['reports_calls.read']
      },
      {
        title: 'System Log',
        path: '/app/reports/system-log',
        icon: FileText,
        requiredPermissions: ['reports_system_log.read']
      },
      {
        title: 'Documentation',
        path: '/app/reports/documentation',
        icon: BookOpen,
        requiredPermissions: ['reports_documentation.read']
      },
      {
        title: 'User Activity',
        path: '/app/user-activity',
        icon: Users,
        requiredPermissions: ['user_activity.read']
      }
    ]
  }
];

export default reportsItems;
